{
  "edit-association-for": "Edit Party Association to",
  "add-new-party-for": "Add party to",
  "percent": "Percent",
  "before-closing-amount": "Before Closing Amount",
  "before-closing-percent": "Before Closing Percent",
  "at-closing-amount": "At Closing Amount",
  "at-closing-percent": "At Closing Percent",
  "payment-id": "Payment ID",
  "cant-get-info": "We can't get information about the contact payment information",
  "edit-association": "Edit Association",
  "add-association": "Add Association",
  "accounting": "Accounting",
  "receipts": "Receipts",
  "disbursements": "Disbursements",
  "basic": "Basic",
  "manual": "Manual",
  "endorsements": "Endorsement",
  "ledger": "Ledger",
  "money-flow": "Money Flow",
  "money-flow-short": "Flow",
  "no-money-flow": "There is no money flow to display for this order.",
  "view-full-diagram": "View full diagram",
  "others": "Others",
  "other-parties": "Other parties",
  "void-ledger": "Currently we don't have Accounting information, please fill the required modules",
  "amount-override": "Amount Override",
  "dislosed-as": "Disclosed As",
  "months": "Months",
  "letter": "Letter",
  "amount": "Amount",
  "description": "Description",
  "code": "Code",
  "kind": "Kind",
  "entry-date": "Entry Date",
  "edit-entry": "Edit Entry",
  "add-entry": "Add Entry",
  "parties": "Parties",
  "full-amount": "Full Amount",
  "reset-value": "Reset Value",
  "reset": "Reset",
  "name": "Name",
  "actions": "Actions",
  "holder": "Holder",
  "accounting-totals": "Accounting Totals",
  "total-receipts": "Total Receipts",
  "all-disbursements": "All Disbursements",
  "underfunded": "Underfunded",
  "overfunded": "Overfunded",
  "balancing": "Balancing",
  "posted-receipts": "Posted Receipts",
  "expected-receipts": "Expected Receipts",
  "posted-disbursements": "Posted Disbursements",
  "expected-disbursements": "Expected Disbursements",
  "lender-owes": "Lender Owes",
  "borrower-owes": "Borrower Owes",
  "earnest-owed": "Earnest Owed",
  "seller-due": "Seller Due",
  "others-due": "Others Due",
  "balanced": "Balance",
  "payment-method": "Payment Method",
  "number": "Number",
  "accounted-for": "Accounted For",
  "add-document-entry": "Add Document",
  "add-payment": "Add payment",
  "annuality": "Annuality",
  "request-revision": "Request Revision",
  "success-revision": "Request to revise the order ledger was sent successfully",
  "error-revision": "An error occurred while processing your request to review the order ledger. Please try again later.",
  "posted": "Posted",
  "true": "True",
  "false": "False",
  "faked": "Faked",
  "overridden": "Overridden",
  "edit-ledger-entry": "Edit Ledger Entry",
  "add-new-ledger-entry": "Add Ledger Entry",
  "cash": "Cash",
  "check": "Check",
  "wire": "Wire",
  "loan-amount": "Loan Amount",
  "purchase-price": "Purchase Price",
  "accountedBy": "Accounted By",
  "totalAmountAccounted": "{{amount}} (Total Amount Accounted)",
  "accountedEntry": "{{amount}} ({{description}})",
  "disbursementsLedger": "Disbursements - Ledger",
  "editLedgerEntry": "Edit Ledger Entry",
  "escrowAccount": "Escrow Account {{number}}",
  "transferAccount": "Transfer Account {{number}}",
  "fields:amount": "Amount",
  "fields:code": "Code",
  "fields:description": "Description",
  "fields:kind": "Kind",
  "fields:entryDate": "Entry Date",
  "fields:letter": "Letter",
  "fields:number": "Number",
  "fields:months": "Total months",
  "fields:months_advanced": "Months payed in advance",
   "fields:annuality": "Annuality",
   "fields:percent": "Percent",
   "fields:associationPercent": "Percent",
  "fields:associationAmount": "Amount",
  "fields:associationKind": "Kind",
  "fields:partyName": "Party Name",
  "fields:partyEmail": "Email",
  "fields:partyKind": "Party Kind",
  "fields:linkedEntryId": "Linked Entry",
  "fields:linkedAmount": "Linked Amount",
  "fields:posted": "Posted",
  "fields:faked": "Faked",
  "fields:overridden": "Overridden",
  "tabs:entry": "Entry",
  "tabs:association": "Association",
  "tabs:party": "Party",
  "tabs:link": "Link",
  "tabs:settings": "Settings",
  "confirmDialog:deleteTitle": "Confirm Delete",
  "confirmDialog:deleteMessage": "This action cannot be undone.",
  "submitState:partialSuccess": "Partial Success",
  "submitState:partialSuccessMessage": "Some operations succeeded, but others failed.",
  "submitState:error": "Error",
  "validation:required": "This field is required",
  "validation:invalidAmount": "Invalid amount",
  "validation:invalidDate": "Invalid date. Use MM/DD/YYYY format.",
  "validation:invalidPercent": "Invalid percentage",
  "no-manual-entries": "No Manual Entries",
  "no-manual-entries-description": "There are no manual entries in this order.",
  "manual-entries-test": "Manual Entries (Test)",
  "manual-entries-test-description": "Select an entry to open the editor modal.",
  "common:processing": "Processing...",
  "common:retry": "Retry",
  "common:select": "Select...",
  "common:cancel": "Cancel",
  "common:save": "Save",
  "common:saving": "Saving...",
  "common:delete": "Delete",
  "errors:generic": "Something went wrong",
  "errors:unknownEntry": "Unknown entry",
  "errors:invalidDate": "Invalid date",
  "errors:linkedAmountExceeded": "Linked amount exceeded",
  "errors:accountedAssociation": "Accounted association",
  "errors:networkError": "Network error. Please check your connection and try again.",
  "errors:retryFailed": "Retry failed. Please try again later.",
   "submitState:loading": "Loading...",
   "submitState:retrying": "Retrying...",
   "config-selector": "Configuration",
   "select-all": "Select All",
   "clear-all": "Clear All",
   "enable-delete": "Enable Delete",
   "enable-posted": "Enable Posted",
   "require-description": "Require Description",
   "common:error": "Error",
   "common:no-description": "No description",
   "errors:unknown": "An unknown error occurred.",
   "flags": "Flags"
}
